import { placeholderImage } from "../lib/placeholders";

export const BUSINESS = {
  name: "Zarco's Decks",
  tagline: "Family-Owned · Premium Deck Builder · Rome, Cartersville & Northwest Georgia",
  phoneMain: "(678) 356-7281",
  phoneMainHref: "tel:+16783567281",
  email: "zarcosdecks@gmail.com",
  emailHref: "mailto:zarcosdecks@gmail.com",
  website: "zarcosdecks.com",
  websiteUrl: "https://zarcosdecks.com",
  serviceArea: "Rome, Cartersville & Northwest Georgia",
  hours: "Mon–Sat · 7:30 AM – 6:00 PM",
};

// Highest-prominence target markets shown at the top of the service-area section.
export const FEATURED_AREAS = [
  "Rome, GA",
  "Cartersville, GA",
  "Acworth, GA",
  "Kennesaw, GA",
  "Northwest Georgia",
];

export const PRIMARY_SERVICE_AREAS = [
  "Marietta, GA",
  "Kennesaw, GA",
  "Woodstock, GA",
  "Acworth, GA",
  "Alpharetta, GA",
  "Roswell, GA",
  "Milton, GA",
  "Suwanee, GA",
  "Canton, GA",
  "Cartersville, GA",
];

export const SECONDARY_SERVICE_AREAS = [
  "Rome, GA",
  "Cumming, GA",
  "Dallas, GA",
  "Dawsonville, GA",
  "Jasper, GA",
];

// Full list of additional communities served (shown beneath the featured markets).
// Retains every previously listed city and adds the Northwest Georgia towns.
export const ADDITIONAL_SERVICE_AREAS = [
  "Marietta, GA",
  "Woodstock, GA",
  "Alpharetta, GA",
  "Roswell, GA",
  "Milton, GA",
  "Suwanee, GA",
  "Canton, GA",
  "Cumming, GA",
  "Dallas, GA",
  "Dawsonville, GA",
  "Jasper, GA",
  "Euharlee, GA",
  "Taylorsville, GA",
  "Emerson, GA",
  "Kingston, GA",
  "Adairsville, GA",
  "Cave Spring, GA",
  "Cedartown, GA",
  "Rockmart, GA",
];

export const SEO_KEYWORDS = [
  "Deck Builder Marietta GA",
  "Deck Builder Kennesaw GA",
  "TimberTech Deck Builder Alpharetta GA",
  "Custom Deck Builder Woodstock GA",
  "Deck Contractor Metro Atlanta",
  "TimberTech Composite Decking North Georgia",
  "Custom Deck Builder Georgia",
];

export const SERVICES = [
  {
    slug: "custom-decks",
    title: "Custom Decks",
    short: "Outdoor spaces designed around your home, your yard, and how you live outside.",
    description:
      "Multi-level builds, wrap-arounds, pool decks, and architectural custom work. Every Zarco's deck is engineered for your slope, your architecture, and the way Metro Atlanta lives outdoors.",
    image: placeholderImage("Custom Deck", { subtitle: "Add custom deck photo" }),
    photo: "/service-custom-decks.webp",
    focal: "center 22%",
    imageLabel: "Custom Deck — Real Project",
  },
  {
    slug: "timbertech-composite",
    title: "TimberTech Composite & PVC Decking",
    short: "Our primary premium decking line — TimberTech composite and Advanced PVC for decades of low-maintenance outdoor living.",
    description:
      "TimberTech composite and Advanced PVC decking installed by experienced crews across Metro Atlanta and North Georgia — our primary premium product family, backed by TimberTech manufacturer warranties. Prefer something else? Quality alternatives like Trex are also available depending on your project and preferences.",
    image: placeholderImage("TimberTech Composite Deck", { subtitle: "Add TimberTech project photo" }),
    photo: "/service-trex-composite.webp",
    imageLabel: "Premium Composite Deck — Real Project",
  },
  {
    slug: "wood-decks",
    title: "Custom Wood Decks",
    short: "Pressure-treated, cedar, and hardwood decks finished for North Georgia climate.",
    description:
      "Classic warmth, hand-fitted joinery, and finishes chosen to handle our humidity and freezing snaps. Maintained right, a Zarco's wood deck is a multi-decade investment.",
    image: placeholderImage("Custom Wood Deck", { subtitle: "Add wood deck photo" }),
    photo: "/project-elevated-deck-01.webp",
    focal: "center 55%",
    imageLabel: "Custom Wood Deck — Real Project",
  },
  {
    slug: "deck-repairs",
    title: "Deck Demolition & Removal",
    short: "Safe tear-out of old or damaged decks, with full cleanup and prep for the new build.",
    description:
      "Careful removal of old or damaged decks, including tear-out, cleanup, and preparation for the new build.",
    image: placeholderImage("Deck Demolition", { subtitle: "Add demolition photo" }),
    photo: "/service-deck-demolition.webp",
    imageLabel: "Deck Demolition & Removal — Real Project",
  },
  {
    slug: "stairs-handrails",
    title: "Stairs & Handrails",
    short: "Code-compliant stair systems and custom railings — cable, aluminum, composite, wood.",
    description:
      "Engineered for safety, comfort, and the right visual proportions for your home. We pair every stair build with rail systems sized to spec and finish.",
    image: placeholderImage("Stairs & Railings", { subtitle: "Add stair build photo" }),
    photo: "/project-covered-porch-stairs.webp",
    focal: "center 45%",
    imageLabel: "Stairs & Railings — Real Project",
  },
  {
    slug: "porches",
    title: "Covered Porches",
    short: "Screened, covered, and open porches that extend your living room outside.",
    description:
      "Roof tie-ins, tongue-and-groove ceilings, beadboard, lighting, fans, and outlets — porches built for Georgia evenings and year-round use.",
    image: placeholderImage("Covered Porch", { subtitle: "Add covered porch photo" }),
    photo: "/project-covered-porch-01.webp",
    focal: "center 40%",
    imageLabel: "Covered Porch — Real Project",
  },
  {
    slug: "outdoor-living",
    title: "Outdoor Living Spaces",
    short: "Pergolas, fire features, outdoor kitchens — full backyard transformations.",
    description:
      "We coordinate decks, shade structures, lighting, and finishes into one cohesive outdoor room you'll actually use — not a list of disconnected upgrades.",
    image: placeholderImage("Outdoor Living Space", { subtitle: "Add full project photo" }),
    photo: "/project-screened-porch-01.webp",
    focal: "center 45%",
    imageLabel: "Outdoor Living — Real Project",
  },
];

export const GALLERY_CATEGORIES = [
  {
    id: "composite-decks",
    title: "Composite Decks",
    description: "Composite deck and covered-porch builds featuring premium composite decking and aluminum railings.",
    items: [
      { label: "Two-Story Covered Porch", src: "/project-covered-porch-elevation.webp", focal: "center 35%" },
      { label: "Composite Deck & Railing Detail", src: "/service-trex-composite.webp", focal: "center 50%" },
    ],
  },
  {
    id: "wood-decks",
    title: "Wood-Frame Decks",
    description: "Pressure-treated framing and posts with durable composite decking and metal balusters.",
    items: [
      { label: "Elevated Two-Story Deck", src: "/project-elevated-deck-01.webp", focal: "center 55%" },
      { label: "Deck Framing & Post Detail", src: "/project-elevated-deck-02.webp", focal: "center 50%" },
    ],
  },
  {
    id: "covered-porches",
    title: "Covered & Screened Porches",
    description: "Roof-tied covered porches and screened outdoor rooms with finished ceilings and railings.",
    items: [
      { label: "Screened Porch — White Siding", src: "/project-screened-porch-01.webp", focal: "center 45%" },
      { label: "Covered Porch — Ceiling Fan & Rail", src: "/project-covered-porch-01.webp", focal: "center 40%" },
    ],
  },
  {
    id: "stairs-railings",
    title: "Stairs & Railings",
    description: "Code-compliant stair systems paired with aluminum and metal-baluster railings.",
    items: [
      { label: "Composite Stairs, Aluminum Rail", src: "/project-covered-porch-stairs.webp", focal: "center 45%" },
      { label: "Exterior Deck Stairs", src: "/project-elevated-deck-stairs.webp", focal: "center 55%" },
    ],
  },
];

// Honest craftsmanship / build-process feature — clearly labeled as work in progress.
export const CRAFTSMANSHIP = {
  overline: "Behind The Build",
  title: "Craftsmanship you can see under the surface.",
  body: "A look inside our covered-porch build — installing a tongue-and-groove pine ceiling with our own crew on framing, hardware, and finish carpentry.",
  image: "/craftsmanship-porch-ceiling.webp",
  focal: "center 55%",
  caption: "Zarco's crew installing a tongue-and-groove porch ceiling",
};

// Testimonials are intentionally omitted until genuine Google Reviews are connected.
// Only real, verified customer reviews may appear on the production site.

// Lead form city dropdown — Rome & Cartersville first, then all served communities.
export const PRIMARY_CITIES_DROPDOWN = [
  "Rome, GA",
  "Cartersville, GA",
  "Acworth, GA",
  "Kennesaw, GA",
  ...ADDITIONAL_SERVICE_AREAS,
  "Other / Not Listed",
];

// 7-card "Why Homeowners Choose" — final list per spec.
export const WHY_CHOOSE = [
  {
    title: "Quality Craftsmanship",
    body: "Hand-fitted joinery, hidden fasteners, structural detail. We build the way we'd build it for our own home.",
  },
  {
    title: "Premium Materials",
    body: "TimberTech composite & PVC, cedar, hardwoods, stainless hardware — we don't compromise on what goes into your deck.",
  },
  {
    title: "Composite Deck Expertise",
    body: "TimberTech is our primary premium composite & PVC line — installed to manufacturer spec, with other quality options like Trex available to fit your project.",
  },
  {
    title: "Permit Assistance",
    body: "We handle drawings, permits, and inspections — so your build is code-compliant from day one with zero hassle for you.",
  },
  {
    title: "Reliable Scheduling",
    body: "Real start dates and real finish dates. When we commit to a timeline, we keep it — and we keep you posted along the way.",
  },
  {
    title: "Honest Pricing",
    body: "Line-item written estimates with no upsell pressure. The number we quote is the number you pay.",
  },
  {
    title: "Excellent Communication",
    body: "You'll know what's happening, who's on-site, and what's coming next — every day, start to finish.",
  },
];

// Family-Owned narrative block.
export const FAMILY_OWNED = {
  overline: "Family-Owned & Operated",
  title: "A family business homeowners across Metro Atlanta trust.",
  subtitle:
    "Zarco's Decks is built on the same standards every family expects in their own backyard — honest work, quality materials, and a finished space you'll enjoy for decades.",
  pillars: [
    {
      title: "Family Business",
      body: "Founded and run by the Zarco family. Every quote, every visit, and every nail goes through us — not a call center.",
    },
    {
      title: "Years of Experience",
      body: "Hundreds of decks, porches, and outdoor living spaces delivered across North Georgia — the kind of experience your investment deserves.",
    },
    {
      title: "True Craftsmanship",
      body: "Hand-cut framing, premium hardware, and finishes you can feel. We measure twice and build once.",
    },
    {
      title: "Local Reputation",
      body: "Most of our work comes from referrals across Marietta, Alpharetta, Woodstock, and Kennesaw. We protect that reputation on every project.",
    },
    {
      title: "Customer Service",
      body: "Calls answered, questions explained, jobsite kept clean. You'll always know exactly where your project stands.",
    },
  ],
};
